import { useState } from 'react'

import { IconButton } from '@awazevr/design-system.components.button'
import { EyeOpen, EyeClosed } from '@awazevr/design-system.components.icon'
import { Input, InputTypes } from '@awazevr/design-system.components.input'

interface IProps {
  [propName: string]: unknown
  iconPlaceholder?: string
}

export const PasswordInput = (props: IProps): JSX.Element => {
  const [inputType, setInputType] = useState<InputTypes>('password')
  const [icon, setIcon] = useState<JSX.Element>(<EyeClosed />)

  const showOrHidePassword = () => {
    inputType === 'password' ? setInputType('text') : setInputType('password')

    inputType === 'password' ? setIcon(<EyeOpen />) : setIcon(<EyeClosed />)
  }

  return (
    <Input
      name="password"
      type={inputType}
      placeholder="Password"
      aria-label="password input"
      iconPosition="right"
      icon={
        <IconButton
          icon={icon}
          title={props.iconPlaceholder ?? 'view or hide password'}
          onClick={showOrHidePassword}
          variant="ghost"
          type="button"
        />
      }
      {...props}
    />
  )
}
